import { createContext, useContext, useState } from 'react';
import useFindIdCard from './hooks/useFindIdCard';
import useFindProjectIdCard from './hooks/useFindProjectIdCard';
import useImagesArray from '../../../hooks/useImagesArray';

const IdCardContext = createContext(null);

export const IdCardProvider = ({ children }) => {
  const [editingCardTagId, setEditingCardTagId] = useState(undefined);
  const [isProjectIdCard, setIsProjectIdCard] = useState(false);

  let card = { tagId: editingCardTagId, isFpso: isProjectIdCard };
  const { idCard: idCard, isLoading: idCardLoading } = useFindIdCard(card);
  const { idCard: projectIdCard, isLoading: idProjectCardLoading } = useFindProjectIdCard(card);
  let filledCard = idCard?.images ? idCard : projectIdCard;
  // aggregate the image data and make array with empty image objects if required
  const { imageArray: idCardImageArray } = useImagesArray(
    filledCard?.images,
    10 // image array capacity
  );
  const [printMode, setPrintMode] = useState(false);

  return (
    <IdCardContext.Provider
      value={{
        idCard,
        projectIdCard,
        idCardLoading,
        idProjectCardLoading,
        idCardImageArray,
        printMode,
        setPrintMode,
        setEditingCardTagId,
        editingCardTagId,
        isProjectIdCard,
        setIsProjectIdCard,
      }}>
      {children}
    </IdCardContext.Provider>
  );
};

export const useIdCard = () => {
  const context = useContext(IdCardContext);
  if (!context) throw Error('Component cannot call `useIdCard` unless wrapped with a `IdCardProvider`');

  return context;
};
